import { graphql } from '@generated/gql';

export const SET_USER_NOTIFICATION_PREFERENCES = graphql(/** GraphQL */ `
  mutation notificationPreferencesModalSetUserNotificationPreferences(
    $input: setUserNotificationPreferencesInput!
  ) {
    setUserNotificationPreferences(input: $input) {
      organizationUser {
        id
      }
    }
  }
`);
